import { render, staticRenderFns } from "./UserHeaderInfo.vue?vue&type=template&id=30b2247e&"
import script from "./UserHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./UserHeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserHeaderInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports